import { render, staticRenderFns } from "./PositionPicker.vue?vue&type=template&id=5a4cb375&scoped=true&"
import script from "./PositionPicker.vue?vue&type=script&lang=js&"
export * from "./PositionPicker.vue?vue&type=script&lang=js&"
import style0 from "./PositionPicker.vue?vue&type=style&index=0&id=5a4cb375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cb375",
  null
  
)

export default component.exports